/**
* @params Header
*/
export default function () {
    const winWidth = $(window).width();
    const propertiesWrapper = $('.properties__wrapper');
    const propertiesDropdownToggle = $('.properties__dropdown-toggle');
    const dropdownPropertiesMenu = $('.properties__dropdown-menu');
    const desktopPropertiesClose = $('.properties__dropdown-menu__close');
    const mobileToggleActive=$('.properties__mobile');
    const mobilePropertiesDropdownToggle = $('.properties__mobile__icon');
    const mobilePropertiesClose = $('.properties__mobile__close-icon');
    const rightArrowProperties = $('.properties__dropdown-menu__link-list-title.have-children');
    const mobileLinksProperties = $('.properties__dropdown-menu__grid-item.mobile');
    const mobileSubLinksProperties = $('.properties__dropdown-menu__grid-item.link-list-mobile');
    const descriptionProperties = $('.properties__dropdown-menu__description');
    const backProperties = $('.properties__dropdown-menu__back');

     // Show/hide the menu on 
     propertiesDropdownToggle.click(function () {
        dropdownPropertiesMenu.toggleClass('active');
        mobilePropertiesClose.css('display', 'block');
        mobileToggleActive.toggleClass('active');
        $(this).parent().parent().addClass('active');
        $(this).children('span').toggleClass('rotate');
        $('hide-line').addClass('line-hidden');
     
        if (winWidth < 768) {
            $(this).css('display', 'none');
            dropdownPropertiesMenu.css('display', 'block');
            propertiesWrapper.css('display', 'none');
            $('body').css('overflow-y', 'hidden');
            $('.resource_hub_filter').css('display', 'none');
        }
    });

    desktopPropertiesClose.click(function () {
        if (dropdownPropertiesMenu.hasClass('active')) {
            dropdownPropertiesMenu.removeClass('active'); // test
        }
        propertiesDropdownToggle.children('span').toggleClass('rotate');
    });

    mobilePropertiesDropdownToggle.click(function () {
        dropdownPropertiesMenu.css('display', 'block');
        $(this).css('display', 'none');
        mobilePropertiesClose.css('display', 'block');
        $(this).parent().parent().addClass('active');
    });

    mobilePropertiesClose.click(function () {
        dropdownPropertiesMenu.css('display', 'none');
        $(this).css('display', 'none');
        mobilePropertiesDropdownToggle.css('display', 'block');
        $(this).parent().parent().removeClass('active');
        propertiesWrapper.css('display', 'flex');
        propertiesDropdownToggle.css('display', 'flex');
        propertiesDropdownToggle.children('span').toggleClass('rotate');
        $('body').css('overflow-y', 'auto');
        $('.resource_hub_filter').css('display', 'block');
    });

    // Show/hide the mobile submenu on click
    rightArrowProperties.click(function () {
        if (winWidth < 768) {
            mobileLinksProperties.animate({ left: '-100%' }, 300, function () {
                $(this).hide();
            });
            mobileSubLinksProperties.animate({ left: '-100%' }, 300, function () {
                $(this).show();
                descriptionProperties.hide();
            });
        }
    });

    backProperties.click(function () {
        mobileLinksProperties.animate({ right: '100%', left: '0' }, 300, function () {
            $(this).show();
        });
        mobileSubLinksProperties.animate({ left: '-100%' }, 300, function () {
            $(this).hide();
            descriptionProperties.show();
        });
    });

    const dropdownMenu = $('.header__dropdown-menu');
    const mobileDropdownToggle = $('.header__mobile__icon');
    const mobileClose = $('.header__mobile__close-icon');
    const mobileLogos=$('.header__mobile__logo');
    const mobileHeader = $('.header__mobile');

    mobileDropdownToggle.click(function () {
        $(this).css('display', 'none');
        mobileClose.css('display', 'block');
        mobileLogos.css('display', 'none');
        mobileHeader.addClass('active');
        dropdownMenu.addClass('active');
    });

    mobileClose.click(function () {
        $(this).css('display', 'none');
        mobileDropdownToggle.css('display', 'block');
        mobileLogos.css('display', 'flex');
        mobileHeader.removeClass('active');
        dropdownMenu.removeClass('active');
        // $(this).parent().parent().removeClass('active');
    });
}
